import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { GestionSAC } from '../../class/gestionSAC';

@Injectable()
export class GestionSACService extends WebService {

    public getGestionSAC (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('company,venue,employee,created_by'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/gestionSACs?${params}`, options);
    }

    public newGestionSAC(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/gestionSACs`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updateGestionSAC(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/gestionSACs/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteGestionSAC(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/gestionSACs/${id}`, { headers: this.headers } );
    }

    public infoGestionSAC(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        params.append('_with', String('company,venue,employee,created_by,commitment,contact'));

        const options = new RequestOptions({search: params, headers: this.headers});

        return this.http.get( `${this.apiUrl}/gestionSACs/${id}?${params}`, options);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/gestionSAC/gestionSAC.service.ts